// Datos fijos de cada app. storeLink = App Store, playStoreLink = Google Play (opcional). Los textos (descripción, soporte y privacidad) viven en Constants/AppsContent.js
export const APPS = [
  {
    id: "gastify",
    name: "Gastify",
    icon: "/assets/apps/gastify/icon.png",
    accent: "#00E676",
    accentDark: "#00BFA5",
    platforms: ["iOS", "Android"],
    tags: ["iOS", "Android", "Flutter", "AWS"],
    storeLink: "https://apps.apple.com/us/app/gastify/id6814643846",
    playStoreLink: "https://play.google.com/store/apps/details?id=com.gastify",
  },
  {
    id: "spiki",
    name: "Spiki",
    icon: "/assets/apps/spiki/icon.png",
    accent: "#7928FF",
    accentDark: "#087BFF",
    platforms: ["iOS"],
    tags: ["iOS", "SwiftUI", "Apple Intelligence"],
    storeLink: "https://apps.apple.com/mx/app/spiki-aprende-ingl%C3%A9s/id6817921226",
  },
  {
    id: "apptoto",
    name: "Apptoto Local",
    icon: "/assets/apps/apptoto/icon.png",
    accent: "#168BEE",
    accentDark: "#0F2D5B",
    platforms: ["iOS", "Android"],
    tags: ["iOS", "Android", "Flutter", "AWS"],
    storeLink: "https://apps.apple.com/mx/app/apptoto-local/id6823741922",
  },
];

export const getApp = (id) => APPS.find((app) => app.id === id);
